var _excluded = ["isActive", "onClick", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
var activeBoxShadowSize = "medium";
var StyledSelectSquareButtonAtm = styled.button.withConfig({
  componentId: "sc-s6lpr7-0"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["", ";display:flex;align-items:center;justify-content:center;width:", ";height:", ";padding:0;border:", " solid ", ";border-radius:", ";background:", ";box-shadow:", ";cursor:pointer;&:hover{box-shadow:", ";}"], transition("border", "box-shadow"), space(12), space(12), unit(1), $isActive ? getBorderColor(theme, $onColor, "high") : "transparent", getBorderRadius(theme, "medium"), getColor(theme, "backgroundLight"), getBoxShadow(theme, $isActive ? activeBoxShadowSize : "nano"), getBoxShadow(theme, activeBoxShadowSize));
});
function SelectSquareButtonAtm(_ref2) {
  var isActive = _ref2.isActive,
    onClick = _ref2.onClick,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledSelectSquareButtonAtm, _extends({
    onClick: onClick,
    type: "button",
    $isActive: !!isActive,
    $onColor: onColor
  }, restProps), children);
}
export default SelectSquareButtonAtm;